import CustomerOrderHistoryPreview from "./CustomerOrderHistoryPreivew";

const PrintCustomerOrderHistory: React.FC = () => {
  return (
    <div className="inner-container">
      <CustomerOrderHistoryPreview />
    </div>
  );
};

export default PrintCustomerOrderHistory;
